<template>
    <div class="split-line-setting">
        <div class="form-group">
            <label>{{ $t("라벨") }}</label>
            <input v-model="localTitle" type="text" class="form-control form-control-sm" :placeholder="$t('라벨 텍스트 (비워두면 선만 표시)')" />
        </div>
        <div class="form-group form-group--row">
            <div class="form-field">
                <label>{{ $t("폰트 크기") }}</label>
                <div class="font-size-row">
                    <input v-model.number="localFontSize" type="number" class="form-control form-control-sm" min="8" max="32" step="1" style="width:70px" />
                    <span class="unit-text">px</span>
                </div>
            </div>
            <div class="form-field">
                <label>{{ $t("선 색상") }}</label>
                <div class="color-input-row">
                    <input v-model="localLineColor" type="color" class="color-swatch" />
                    <input v-model="localLineColor" type="text" class="form-control form-control-sm" placeholder="#cccccc" />
                </div>
            </div>
        </div>
        <div class="setting-actions">
            <button type="button" class="btn btn-sm btn-secondary" @click="$emit('on-modal-cancel')">{{ $t("취소") }}</button>
            <button type="button" class="btn btn-sm btn-primary" @click="onSave">{{ $t("저장") }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "SplitLineSetting",
    props: {
        initSetting: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            localTitle: "",
            localLineColor: "",
            localFontSize: 11,
        };
    },
    mounted() {
        this.localTitle = this.initSetting.title || "";
        this.localLineColor = this.initSetting.lineColor || "";
        this.localFontSize = this.initSetting.fontSize || 11;
    },
    methods: {
        onSave() {
            this.$emit("on-modal-ok", {
                title: this.localTitle,
                lineColor: this.localLineColor || "",
                fontSize: this.localFontSize || 11,
            });
        },
    },
};
</script>

<style scoped>
.split-line-setting {
    padding: 16px 20px 12px;
}

.form-group {
    margin-bottom: 14px;
}

.form-group label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    color: #555;
    margin-bottom: 4px;
}

.form-group--row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.form-field {
    flex: 1;
    min-width: 120px;
}

.font-size-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unit-text {
    font-size: 12px;
    color: #888;
}

.color-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.color-swatch {
    width: 32px;
    height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 1px;
    cursor: pointer;
    flex-shrink: 0;
}

.setting-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #eee;
    margin-top: 4px;
}
</style>
